var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 7 12",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1e2025",
    d: "M3 0h1M2 1h1M2 2h1M1 3h1M1 4h1M0 5h1M0 6h1m0 1h1M1 8h1m0 1h1m-1 1h1m0 1h1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M4 0h3M3 1h1m2 0h1M3 2h1m2 0h1M2 3h1m3 0h1M2 4h1m3 0h1M1 5h1m4 0h1M1 6h1m4 0h1M2 7h1m3 0h1M2 8h1m3 0h1M3 9h1m2 0h1m-4 1h1m2 0h1m-3 1h3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#657d8c",
    d: "M4 1h1M4 2h1M3 3h1M3 4h1M2 5h1M2 6h1m0 1h1M3 8h1m0 1h1m-1 1h1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#03031d",
    d: "M5 1h1M5 2h1M5 3h1M5 4h1M5 5h1M5 6h1M5 7h1M5 8h1M5 9h1m-1 1h1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#24304e",
    d: "M4 3h1M4 4h1M3 5h2M3 6h2M4 7h1M4 8h1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelected);
export default __webpack_public_path__ + "static/media/selected.e44fbd264a9019f18b13da40284f6988.svg";
export { ForwardRef as ReactComponent };